import { Box, Tooltip, Typography } from "@mui/material";
import CheckRounded from "@mui/icons-material/CheckRounded";

import { invoiceStylePresets, type InvoiceStylePresetName } from "../constants/invoiceStylePresets";

interface InvoicePresetCardsProps {
  selected: InvoiceStylePresetName | null;
  onSelect: (preset: InvoiceStylePresetName) => void;
}

const presetMeta: Array<{
  id: InvoiceStylePresetName;
  label: string;
  description: string;
}> = [
  {
    id: "flownect",
    label: "Flownect",
    description: "Brand orange",
  },
  {
    id: "classic",
    label: "Classic",
    description: "Warm and formal",
  },
  {
    id: "modern",
    label: "Modern",
    description: "Cool blue",
  },
  {
    id: "minimal",
    label: "Minimal",
    description: "Black and white",
  },
];

export const InvoicePresetCards = ({ selected, onSelect }: InvoicePresetCardsProps) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gap: 0.75,
    }}
  >
    {presetMeta.map((preset) => {
      const style = invoiceStylePresets[preset.id];
      const isActive = selected === preset.id;
      const accentColor = style.colors.total;

      return (
        <Tooltip key={preset.id} title={preset.description} placement="top" arrow>
          <Box
            component="button"
            type="button"
            onClick={() => onSelect(preset.id)}
            aria-pressed={isActive}
            sx={{
              position: "relative",
              minWidth: 0,
              height: 48,
              px: 1,
              display: "flex",
              alignItems: "center",
              gap: 0.75,

              border: "1px solid",
              borderColor: isActive ? accentColor : "#E2E8F0",
              borderRadius: 1.5,

              bgcolor: isActive ? `${accentColor}0D` : style.colors.cardBackground,

              color: style.colors.title,
              cursor: "pointer",
              font: "inherit",
              textAlign: "left",

              transition: "border-color 120ms ease, background-color 120ms ease",

              "&:hover": {
                borderColor: accentColor,
                bgcolor: `${accentColor}0A`,
              },

              "&:focus-visible": {
                outline: `2px solid ${accentColor}`,
                outlineOffset: 1,
              },
            }}
          >
            {/* Vista rápida de colores */}
            <Box
              sx={{
                width: 26,
                height: 26,
                flexShrink: 0,
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                overflow: "hidden",
                borderRadius: 1,
                border: `1px solid ${style.colors.border}`,
              }}
            >
              <Box sx={{ bgcolor: style.colors.pageBackground }} />
              <Box sx={{ bgcolor: style.colors.title }} />
              <Box sx={{ bgcolor: style.colors.icon }} />
              <Box sx={{ bgcolor: style.colors.total }} />
            </Box>

            <Typography
              noWrap
              sx={{
                minWidth: 0,
                fontSize: "0.72rem",
                fontWeight: 800,
                lineHeight: 1,
              }}
            >
              {preset.label}
            </Typography>

            {isActive ? (
              <Box
                sx={{
                  position: "absolute",
                  top: 3,
                  right: 3,
                  width: 15,
                  height: 15,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "50%",
                  bgcolor: accentColor,
                }}
              >
                <CheckRounded
                  sx={{
                    fontSize: 11,
                    color: "#FFFFFF",
                  }}
                />
              </Box>
            ) : null}
          </Box>
        </Tooltip>
      );
    })}
  </Box>
);
